import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/admin/AuthContext";
import { Login } from "@/admin/Login";
import { AdminLayout } from "@/admin/AdminLayout";
import { Dashboard } from "@/admin/pages/Dashboard";
import { GamesManager } from "@/admin/pages/GamesManager";
import { SettingsManager } from "@/admin/pages/SettingsManager";
import { ImagesManager } from "@/admin/pages/ImagesManager";
import { PromptsManager } from "@/admin/pages/PromptsManager";
import { LogsViewer } from "@/admin/pages/LogsViewer";
import { BackupPanel } from "@/admin/pages/BackupPanel";
import { CategoriesManager } from "@/admin/pages/CategoriesManager";
import { BannersManager } from "@/admin/pages/BannersManager";
import { UsersManager } from "@/admin/pages/UsersManager";
import { FilesManager } from "@/admin/pages/FilesManager";
import { CodeEditor } from "@/admin/pages/CodeEditor";
import { SeoManager } from "@/admin/pages/SeoManager";
import { AiAssistant } from "@/admin/pages/AiAssistant";
import { PlatformsManager } from "@/admin/pages/PlatformsManager";
import { AgeGateManager } from "@/admin/pages/AgeGateManager";
import { LegalDocsManager } from "@/admin/pages/LegalDocsManager";
import { AppManager } from "@/admin/pages/AppManager";
import { SupportManager } from "@/admin/pages/SupportManager";
import { FeaturedLaunchManager } from "@/admin/pages/FeaturedLaunchManager";
import { PublicUsersManager } from "@/admin/pages/PublicUsersManager";

const Protected = ({ children }) => {
  const { user, checking } = useAuth();
  if (checking)
    return (
      <div className="min-h-screen bg-[#120D0D] flex items-center justify-center">
        <div className="w-10 h-10 rounded-full border-2 border-[#F5C542]/30 border-t-[#F5C542] animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

export const AdminApp = () => (
  <AuthProvider>
    <Toaster theme="dark" position="top-right" richColors closeButton />
    <Routes>
      <Route path="login" element={<Login />} />
      <Route
        element={
          <Protected>
            <AdminLayout />
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="ia" element={<AiAssistant />} />
        <Route path="jogos" element={<GamesManager />} />
        <Route path="plataformas" element={<PlatformsManager />} />
        <Route path="categorias" element={<CategoriesManager />} />
        <Route path="banners" element={<BannersManager />} />
        <Route path="imagens" element={<ImagesManager />} />
        <Route path="arquivos" element={<FilesManager />} />
        <Route path="prompts" element={<PromptsManager />} />
        <Route path="editor" element={<CodeEditor />} />
        <Route path="usuarios" element={<UsersManager />} />
        <Route path="usuarios-publicos" element={<PublicUsersManager />} />
        <Route path="lancamento" element={<FeaturedLaunchManager />} />
        <Route path="seo" element={<SeoManager />} />
        <Route path="configuracoes" element={<SettingsManager />} />
        <Route path="verificacao-idade" element={<AgeGateManager />} />
        <Route path="documentos-legais" element={<LegalDocsManager />} />
        <Route path="aplicativo" element={<AppManager />} />
        <Route path="atendimento" element={<SupportManager />} />
        <Route path="logs" element={<LogsViewer />} />
        <Route path="backup" element={<BackupPanel />} />
      </Route>
    </Routes>
  </AuthProvider>
);
